import * as React from "react";
import PropTypes from "prop-types";

import { useProductId } from "../../hooks/use-product-attributes";
import { useRouter } from "next/router";
import { usePDPRefs } from "@lululemon/ecom-pdp/src/context/pdp-refs.context";
import GoesWellWithCarousel from "./goes-well-with-carousel";

const { useCallback, useEffect, useState } = React;

const MIN_LENGTH = 2;

const GoesWellWithAdapter = ({ fusionExperimentVariant }) => {
  const [resultCount, setResultCount] = useState(null);

  const productId = useProductId();
  const { locale } = useRouter();
  const { gwwRef } = usePDPRefs();

  // callback for ItemRecommendationCarousel to set count of returned results
  const onResolved = useCallback(
    ({ products }) => setResultCount(products?.length || 0),
    []
  );

  // useEffect to set result count to null when retrieving new recommendations
  useEffect(() => {
    setResultCount(null);
  }, [productId]);

  // render component while fetching or fetched results has minimum number of results
  const shouldRenderGoesWellWithRecos =
    resultCount === null || resultCount >= MIN_LENGTH;

  return !shouldRenderGoesWellWithRecos ? null : (
    <GoesWellWithCarousel
      fusionExperimentVariant={fusionExperimentVariant || undefined}
      gwwRef={gwwRef}
      locale={locale}
      productId={productId}
      onResolved={onResolved}
    />
  );
};

GoesWellWithAdapter.propTypes = {
  fusionExperimentVariant: PropTypes.string,
};

GoesWellWithAdapter.defaultProps = {
  fusionExperimentVariant: "",
};

export default GoesWellWithAdapter;
